<template>
    <div>
        <a-skeleton :loading="loading" active >
            <a-list item-layout="horizontal" size="small" :data-source="data">
                <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                        <user-link slot="title" class="username" :id="item.id" :name="item.username"></user-link>
                        <a-avatar slot="avatar" :src="item.avatar" shape="square"></a-avatar>
                    </a-list-item-meta>
                </a-list-item>
            </a-list>
            <a-pagination :current="Number($route.params.page)" :total="followees" 
                :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
            />
        </a-skeleton>
    </div>
</template>

<script>
import UserLink from '../../../components/UserLink.vue';
import { mapState } from 'vuex';
import axios from '../../../plugins/axios'

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.params.page);
        next();
    },
    data: () => ({
        data: [],
        loading: false,
    }),
    computed: {
        ...mapState('$user', [
            'userid', 'followees',
        ]),
    },
    methods: {
        async load(page) {
            this.loading = true;
            const { data } = await axios.get("/backend/user/my.php", {
                params: {
                    id: this.userid, type: "followee", page
                }
            });
            this.loading = false;
            this.data = data.list;
        },
        change(page) {
            this.$router.push({ params: { page } });
        }
    },
    components: {
        UserLink,
    }
}
</script>

<style lang="less" scoped>
.username {
    font-size: 18px;
    font-weight: bold;
}
</style>